<template>
    <section class="chart-container">
          <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="统计维度" >
					<el-select v-model="dimension" placeholder="请选择统计维度"  style="width:100px"   @change="getDataList" >
						<el-option label="项目" value="project"></el-option>
						<el-option label="点位" value="device"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags  style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="功能区" >
					<el-select v-model="filters.functionalArea"  reserve-keyword>
                        <el-option label="全部" value=""></el-option>
						<el-option
							v-for="item in functionalAreaList"
							:label="item.name"
							:value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类型">
					<el-select v-model="filters.type">
						<el-option label="同比" value="yoy"></el-option>
						<el-option label="环比" value="qoq"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数据类型">
					<el-select v-model="filters.datatype"  @change="changeType"   style="width:100px" >
						<!-- <el-option label="小时" value="hour"></el-option> -->
						<el-option label="天" value="day"></el-option>
                        <el-option label="月" value="month"></el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="时间">
					<el-date-picker  v-model="filters.time" :type="timeType"  value-format="yyyy-MM-dd HH:mm:ss">  </el-date-picker>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ResetButtonShow ></my-button>
				</el-form-item>
			</el-form>
		</el-col>

       <el-table :data="dataList"  highlight-current-row v-loading="listLoading" border :height="formHeight">
           	<el-table-column type="index" label="序号" width="60"  > </el-table-column>
			<el-table-column  label="项目名称"   min-width="120" prop="projectName" > </el-table-column>
            <el-table-column  label="功能区名称"   min-width="120" prop="functionalAreaName"   v-if="dimension=='device'"></el-table-column>
			<el-table-column label="点位名称"   min-width="120" prop="deviceName"     v-if="dimension=='device'"></el-table-column>
            <el-table-column  label="噪声"  min-width="120" sortable>
				<template slot-scope="scope">
					<span  v-if="scope.row.ratioLeqRate==null||scope.row.ratioLeqRate==undefined||scope.row.ratioLeqRate=='-'">
						<span>-</span>
					</span>
                    <span  v-else-if="scope.row.ratioLeqRate=='0'">
						<span style="color:#43ce17">0%</span>
					</span>
                    <span  v-else-if="scope.row.ratioLeqRate.indexOf('-')!=-1">
						<span style="color:#43ce17">{{scope.row.ratioLeqRate.substring(1)}}%</span>
						<img style="padding-top:6px;" src="/static/arrow-down.png">
					</span>
					<span  v-else>
						<span style="color:red;">{{scope.row.ratioLeqRate}}%</span>
						<img style="padding-top:6px;" src="/static/arrow-up.png">
					</span>
				</template>
			</el-table-column>
			<el-table-column  label="昼数据"  min-width="120" sortable>
				<template slot-scope="scope">
					<span  v-if="scope.row.ratioLdRate==null||scope.row.ratioLdRate==undefined||scope.row.ratioLdRate=='-'">
						<span>-</span>
					</span>
                    <span  v-else-if="scope.row.ratioLdRate=='0'">
						<span style="color:#43ce17">0%</span>
					</span>
                    <span  v-else-if="scope.row.ratioLdRate.indexOf('-')!=-1">
						<span style="color:#43ce17">{{scope.row.ratioLdRate.substring(1)}}%</span>
						<img style="padding-top:6px;" src="/static/arrow-down.png">
					</span>
					<span  v-else>
						<span style="color:red;">{{scope.row.ratioLdRate}}%</span>
						<img style="padding-top:6px;" src="/static/arrow-up.png">
					</span>
				</template>
			</el-table-column>
			<el-table-column  label="夜数据"  min-width="120" sortable>
				<template slot-scope="scope">
					<span  v-if="scope.row.ratioLnRate==null||scope.row.ratioLnRate==undefined||scope.row.ratioLnRate=='-'">
						<span>-</span>
					</span>
                    <span  v-else-if="scope.row.ratioLnRate=='0'">
						<span style="color:#43ce17">0%</span>
					</span>
                    <span  v-else-if="scope.row.ratioLnRate.indexOf('-')!=-1">
						<span style="color:#43ce17">{{scope.row.ratioLnRate.substring(1)}}%</span>
						<img style="padding-top:6px;" src="/static/arrow-down.png">
					</span>
					<span  v-else>
						<span style="color:red;">{{scope.row.ratioLnRate}}%</span>
						<img style="padding-top:6px;" src="/static/arrow-up.png">
					</span>
				</template>
			</el-table-column>
		</el-table>
        
    </section>
</template>

<script>
    import {getProjects,selectContrastList,getFunctionalAreaList} from '../../api/api';
    import {formatDate} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

	export default {
        components: { myButton },
        data() {
            return {
                filters: {
                    projectId:[],
                    time:"",
                    datatype:"day",
					type:"qoq",
                    functionalArea:"",
                    quarter:"1"
                },
                dimension:"device",
                projects:[],
                dataList:[],
                listLoading:false,
                formHeight:0,

                functionalAreaList:[],
				functionalAreaMap:new Map(),
				projectMap:new Map(),
                timeType:"date",
                chooseDimension:""
            }
        },
        methods: {
            changeType(){
                 if(this.filters.datatype=="day"){
                    this.timeType="date";
                    // this.factors=this.dayfactors;
                }else if(this.filters.datatype=="month"){
                    this.timeType="month";
                    // this.factors=this.dayfactors;
                }
            },
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="reset"){
					this.reset();
				}else if(type=="export"){
					this.exportData();
				}
			},
            reset(){
                this.filters.projectId=[];
                this.filters.functionalArea="";
                this.filters.dataType="day";
                this.timeType="date";
                var data=new Date();
                data.setSeconds(0);
                data.setMinutes(0);
                data.setHours(6);
                data.setTime(data.setDate(data.getDate()-1));
                this.filters.time=formatDate(data);
                this.factors=this.dayfactors;
            },
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    var tHeader =  [];
                    var filterVal = [];  
                    if(this.chooseDimension=="device"){
                        tHeader =  [ '排名','项目名称','功能区名称', '点位名称', '数值（dB）' ];
                        filterVal = ['index','projectName', 'functionalAreaName', 'deviceName',this.chooseFac ];  
                    }else{
                        tHeader =  [ '排名','项目名称', '数值（dB）' ];
                        filterVal = ['index','projectName' ,this.chooseFac ];  
                    }

                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.dataList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '数值排名数据',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						for (let index = 0; index <  this.projects.length; index++) {
							const element =  this.projects[index];
							this.projectMap.set(element.projectId.toString(),element.name);
						}		
						this.getDataList();

					}
				});
			},
            getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
                    this.functionalAreaList=res.data.data;
					for (let index = 0; index <  this.functionalAreaList.length; index++) {
						const element =  this.functionalAreaList[index];
						this.functionalAreaMap.set(element.id.toString(),element.name);
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                if(this.filters.projectId.toString()==""){
                    this.$message({
						message: "项目不能为空",
						type: 'error'
					})
					return;
                } 
                let para = {
                    projectIdStr:this.filters.projectId.toString(),
                    functionalAreaId:this.filters.functionalArea,
                    dataType:this.filters.datatype,
					contrastType:this.filters.type,
                    dimension:this.dimension,
                    time:  this.filters.time
                };

                this.listLoading = true;
                
				selectContrastList(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result=="true"){
                        this.chooseDimension=this.dimension;
                        this.dataList = res.data.datas;
                        for(var i=0;i<this.dataList.length;i++){
							this.dataList[i].functionalAreaName=this.functionalAreaMap.get(this.dataList[i].functionalAreaId);
							this.dataList[i].projectName=this.projectMap.get(this.dataList[i].projectId);
                        }
                    } else{
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
                    }
				});
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)

            var data=new Date();
            data.setSeconds(0);
            data.setMinutes(0);
            data.setHours(6);
            data.setTime(data.setDate(data.getDate()-1));
            this.filters.time=formatDate(data);

            this.factors=this.dayfactors;

            this.getProjects();
            this.getFunctionalAreaList();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// Analy.vue?6b67d02c